// // src\themes\default\elements\Product\ProductInformation.tsx
// 'use client';

// import { Minus, Plus } from 'lucide-react';

// import { useState } from 'react';

// import Link from 'next/link';

// import {
//   Collapsible,
//   CollapsibleContent,
//   CollapsibleTrigger,
// } from '@/components/ui/collapsible';
// import { Heading } from '@/components/ui/Heading';
// import {
//   Tooltip,
//   TooltipContent,
//   TooltipTrigger,
// } from '@/components/ui/tooltip';
// import { useDictionary } from '@/core/hooks/use-dictionary';
// import {
//   MainShopProduct,
//   ProductColor,
// } from '@/core/models/shop-product-model';

// import { cn } from '@/core/lib/utils';
// import { formatPrice, formatWeight } from '@/utils/formatUtils';
// import { AddToCartButton } from '@/themes/default/elements/Product/AddToCartButton';

// type ProductInformationProps = {
//   product: MainShopProduct;
//   colors: ProductColor[];
// };

// export default function ProductInformation({
//   product,
//   colors,
// }: ProductInformationProps) {
//   const [openState, setOpenState] = useState({ details: false, sizes: false });
//   const { dictionary } = useDictionary();

//   return (
//     <div className="lg:col-span-1 flex flex-col text-primary-900 space-y-6">
//       <div className="space-y-2">
//         {/* heading */}
//         <div>
//           <Heading level={1} className="text-base">
//             {product.title + ' ' + product.color_title}
//           </Heading>
//           {product.description && (
//             <p className="text-sm text-primary-600 leading-6">{product.description}</p>
//           )}
//         </div>
//         {/* color */}
//         <div className="flex flex-wrap gap-3 my-6">
//           {Array.isArray(colors) ? colors?.map(color => (
//             <Tooltip key={color.product_id}>
//               <TooltipTrigger asChild>
//                 <Link href={`/shop/product/${color.product_id}/${product.slug}`}>
//                   <div
//                     className={cn("size-6 rounded-full border border-primary-300 cursor-pointer hover:ring-2 hover:ring-[#C6B8A3] transition-transform hover:scale-110",
//                       //@ts-ignore
//                       product.id === color.product_id && "ring-2 ring-primary-500"
//                     )}
//                     style={{ backgroundColor: color.color_code }}
//                     title={color.color_title}
//                   />
//                 </Link>
//               </TooltipTrigger>
//               <TooltipContent>
//                 <p className="text-sm text-primary-0">{color.color_title}</p>
//               </TooltipContent>
//             </Tooltip>
//           )) : <Tooltip >
//             <TooltipTrigger asChild>
//               <div
//                 className={cn("size-6 rounded-full border border-primary-300 cursor-pointer hover:ring-2 hover:ring-[#C6B8A3] transition-transform hover:scale-110",
//                 )}
//                 style={{ backgroundColor: product.color_code }}
//                 title={product.color_title}
//               />
//             </TooltipTrigger>
//             <TooltipContent>
//               <p className="text-sm text-primary-0">{product.color_title}</p>
//             </TooltipContent>
//           </Tooltip>}
//         </div>

//         {/* detail */}
//         <div>
//           {product.meta_fields.length > 0 && (
//             <Collapsible
//               open={openState.details}
//               onOpenChange={open =>
//                 setOpenState(prev => ({ ...prev, details: open }))
//               }
//             >
//               <CollapsibleTrigger asChild>
//                 <button className="flex items-center justify-between gap-2 text-sm py-3 text-primary-900">
//                   {openState.details ? (
//                     <Minus className="size-4" />
//                   ) : (
//                     <Plus className="size-4" />
//                   )}
//                   {dictionary.ui?.product.details.show}
//                 </button>
//               </CollapsibleTrigger>
//               <CollapsibleContent>
//                 {product.meta_fields.map((item, index) => (
//                   <p key={index} className="text-sm text-primary-600 my-2">
//                     {item.label} : {item.value}
//                   </p>
//                 ))}
//               </CollapsibleContent>
//             </Collapsible>
//           )}
//           <Collapsible
//             open={openState.sizes}
//             onOpenChange={open =>
//               setOpenState(prev => ({ ...prev, sizes: open }))
//             }
//           >
//             <CollapsibleTrigger asChild>
//               <button className="flex items-center justify-between gap-2 text-sm text-primary-900 py-3">
//                 {openState.sizes ? (
//                   <Minus className="size-4" />
//                 ) : (
//                   <Plus className="size-4" />
//                 )}
//                 {dictionary.ui?.product.sizes.show}
//               </button>
//             </CollapsibleTrigger>
//             <CollapsibleContent>
//               {product.fabric_area && (
//                 <p className="text-sm text-primary-600 my-2">
//                   {dictionary.forms?.fabric_area} :{' '}
//                   <span>{product.fabric_area}</span>
//                 </p>
//               )}

//               {product.weight && (
//                 <p className="text-sm text-primary-600 my-2">
//                   {formatWeight(product.weight, dictionary)}
//                 </p>
//               )}
//               {product.overalsize && (
//                 <p className="text-sm text-primary-600 my-2">
//                   {dictionary.forms?.overalsize} :{' '}
//                   <span>{product.overalsize}</span>
//                 </p>
//               )}
//             </CollapsibleContent>
//           </Collapsible>
//         </div>
//         {/* price and discount */}
//         <div className="flex gap-3 items-center mb-4">
//           {product.discount_percent > 0 ? (
//             <div className='space-y-2'>
//               <span className="text-red-500 line-through">
//                 {formatPrice(Number(product.price))} {dictionary.ui?.product.currency}
//               </span>
//               <Heading className='text-base'>
//                 {formatPrice(Number(product.final_price))} {dictionary.ui?.product.currency}
//               </Heading>
//             </div>
//           ) : (
//             <Heading className='text-base'>
//               {formatPrice(Number(product.price))} {dictionary.ui?.product.currency}
//             </Heading>
//           )}
//         </div>
//       </div>

//       {/* button */}
//       <div>
//         <AddToCartButton
//           productInfo={product}
//           productInventory={product.inventory}
//         />
//         {product.content && (
//           <p className="text-sm text-primary-600 mt-4 leading-6">{product.content}</p>
//         )}
//       </div>
//     </div >
//   );
// }



// src\themes\default\elements\Product\ProductInformation.tsx
'use client';

import { Minus, Plus } from 'lucide-react';

import { useState } from 'react';

import Link from 'next/link';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import { Heading } from '@/components/ui/Heading';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useDictionary } from '@/core/hooks/use-dictionary';
import {
  MainShopProduct,
  ProductColor,
} from '@/core/models/shop-product-model';

import { cn } from '@/core/lib/utils';
import { formatPrice, formatWeight } from '@/utils/formatUtils';
import { AddToCartButton } from '@/themes/default/elements/Product/AddToCartButton';

type ProductInformationProps = {
  product: MainShopProduct;
  colors: ProductColor[];
};

export default function ProductInformation({
  product,
  colors,
}: ProductInformationProps) {
  const [openState, setOpenState] = useState({ details: false, sizes: false });
  const { dictionary } = useDictionary();

  // فقط فیلدهایی که مقدار واقعی دارن (نه null/undefined/رشته‌ی خالی)
  const filledMetaFields = product.meta_fields.filter(
    item =>
      item.value !== null &&
      item.value !== undefined &&
      String(item.value).trim() !== ''
  );

  return (
    <div className="lg:col-span-1 flex flex-col text-primary-900 space-y-6">
      <div className="space-y-2">
        {/* heading */}
        <div>
          <Heading level={1} className="text-base">
            {product.title + ' ' + product.color_title}
          </Heading>
          {product.description && (
            <p className="text-sm text-primary-600 leading-6">{product.description}</p>
          )}
        </div>
        {/* color */}
        <div className="flex flex-wrap gap-3 my-6">
          {Array.isArray(colors) ? colors?.map(color => (
            <Tooltip key={color.product_id}>
              <TooltipTrigger asChild>
                <Link href={`/shop/product/${color.product_id}/${product.slug}`}>
                  <div
                    className={cn("size-6 rounded-full border border-primary-300 cursor-pointer hover:ring-2 hover:ring-[#C6B8A3] transition-transform hover:scale-110",
                      //@ts-ignore
                      product.id === color.product_id && "ring-2 ring-primary-500"
                    )}
                    style={{ backgroundColor: color.color_code }}
                    title={color.color_title}
                  />
                </Link>
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-sm text-primary-0">{color.color_title}</p>
              </TooltipContent>
            </Tooltip>
          )) : <Tooltip >
            <TooltipTrigger asChild>
              <div
                className={cn("size-6 rounded-full border border-primary-300 cursor-pointer hover:ring-2 hover:ring-[#C6B8A3] transition-transform hover:scale-110",
                )}
                style={{ backgroundColor: product.color_code }}
                title={product.color_title}
              />
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-sm text-primary-0">{product.color_title}</p>
            </TooltipContent>
          </Tooltip>}
        </div>

        {/* detail */}
        <div>
          {filledMetaFields.length > 0 && (
            <Collapsible
              open={openState.details}
              onOpenChange={open =>
                setOpenState(prev => ({ ...prev, details: open }))
              }
            >
              <CollapsibleTrigger asChild>
                <button className="flex items-center justify-between gap-2 text-sm py-3 text-primary-900">
                  {openState.details ? (
                    <Minus className="size-4" />
                  ) : (
                    <Plus className="size-4" />
                  )}
                  {dictionary.ui?.product.details.show}
                </button>
              </CollapsibleTrigger>
              <CollapsibleContent>
                {filledMetaFields.map((item, index) => (
                  <p key={index} className="text-sm text-primary-600 my-2">
                    {item.label} : {item.value}
                  </p>
                ))}
              </CollapsibleContent>
            </Collapsible>
          )}
          <Collapsible
            open={openState.sizes}
            onOpenChange={open =>
              setOpenState(prev => ({ ...prev, sizes: open }))
            }
          >
            <CollapsibleTrigger asChild>
              <button className="flex items-center justify-between gap-2 text-sm text-primary-900 py-3">
                {openState.sizes ? (
                  <Minus className="size-4" />
                ) : (
                  <Plus className="size-4" />
                )}
                {dictionary.ui?.product.sizes.show}
              </button>
            </CollapsibleTrigger>
            <CollapsibleContent>
              {product.fabric_area && (
                <p className="text-sm text-primary-600 my-2">
                  {dictionary.forms?.fabric_area} :{' '}
                  <span>{product.fabric_area}</span>
                </p>
              )}

              {product.weight && (
                <p className="text-sm text-primary-600 my-2">
                  {formatWeight(product.weight, dictionary)}
                </p>
              )}
              {product.overalsize && (
                <p className="text-sm text-primary-600 my-2">
                  {dictionary.forms?.overalsize} :{' '}
                  <span>{product.overalsize}</span>
                </p>
              )}
            </CollapsibleContent>
          </Collapsible>
        </div>
        {/* price and discount */}
        <div className="flex gap-3 items-center mb-4">
          {product.discount_percent > 0 ? (
            <div className='space-y-2'>
              <span className="text-red-500 line-through">
                {formatPrice(Number(product.price))} {dictionary.ui?.product.currency}
              </span>
              <Heading className='text-base'>
                {formatPrice(Number(product.final_price))} {dictionary.ui?.product.currency}
              </Heading>
            </div>
          ) : (
            <Heading className='text-base'>
              {formatPrice(Number(product.price))} {dictionary.ui?.product.currency}
            </Heading>
          )}
        </div>
      </div>

      {/* button */}
      <div>
        <AddToCartButton
          productInfo={product}
          productInventory={product.inventory}
        />
        {product.content && (
          <p className="text-sm text-primary-600 mt-4 leading-6">{product.content}</p>
        )}
      </div>
    </div >
  );
}